import { createContext, useContext, useState, useEffect } from 'react';
import { themes } from './theme';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try {
      const stored = localStorage.getItem('limestone-theme');
      if (stored !== null) return stored === 'dark';
      // Default to dark mode
      return true;
    } catch {
      return false;
    }
  });

  const t = isDark ? themes.dark : themes.light;

  useEffect(() => {
    try {
      localStorage.setItem('limestone-theme', isDark ? 'dark' : 'light');
    } catch {}
    // Update document background so html/body match
    document.documentElement.style.backgroundColor = t.bg;
    document.body.style.backgroundColor = t.bg;
  }, [isDark, t.bg]);

  // Listen for OS preference changes
  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!mq) return;
    const handler = (e) => {
      const stored = localStorage.getItem('limestone-theme');
      if (!stored) setIsDark(e.matches);
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = () => setIsDark((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ isDark, t, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
